module.exports = "<div>\n  <h1> Curl Command </h1>\n  <img class=\"sideimg\" title=\"Curl Command\" src=\"{{image}}\" alt=\"Curl Command\">\n</div>"